import { Button, Card, FormattedMessageDiv } from '@odmonorepo/core-components';
import { useNavigate } from '@tanstack/react-router';
import { useApplication } from 'merchant-api/unified';
import { Stack } from 'react-bootstrap';

export function DeclinedCard() {
  const navigate = useNavigate();
  const { applicationData } = useApplication();
  
  return (
    <Stack gap={6} style={{maxWidth: '600px', margin: 'auto'}}>
      <div className="d-flex flex-column align-items-center">
        <FormattedMessageDiv className="h3 text-center" id="application.declined.title"/>
      </div>
      <Card bodyClassName="px-md-8">
        <Stack gap={5}>
          <FormattedMessageDiv id="application.declined.msg" />
          <FormattedMessageDiv id="loan.advisor.questions" values={{ tel: (txt: any) => <a href={`tel:${txt}`} className="fw-bold">{txt}</a> }} />
          {applicationData?.type === 'RENEWAL' && (
            <div className="d-flex justify-content-center">
              <Button onClick={() => navigate({ to: '/' })}>
                <FormattedMessageDiv id="btn.returnToDashboard" />
              </Button>
            </div>
          )}
        </Stack>
      </Card>
    </Stack>
  );
}

export default DeclinedCard;
